export const PLANS = {
  free: {
    id: 'free',
    name: 'Free',
    price: 0,
    priceLabel: 'Free forever',
    image: '/images/plans/free-plan.png',
    credits: 750,
    creditsLabel: '750 credits / month',
    monthlyReset: true,
    leadLimit: 10,
    leadLimitLabel: '10 active leads',
    leadValueLimit: 10000,
    leadValueLimitLabel: 'Leads valued under $10,000',
    unlimited: false,
    color: 'gray',
    trialDays: 0,
    features: [
      '750 credits per month',
      'Up to 10 active leads',
      'Leads valued under $10,000',
      'Deep research (uses credits)',
      'Contact unlock (email & phone)',
      'Lead pipeline & activity log',
      'Submit discoveries',
    ],
    cta: 'Get Started Free',
  },
  starter: {
    id: 'starter',
    name: 'Starter',
    price: 49,
    priceLabel: 'USD $49 / month',
    image: '/images/plans/starter-plan.png',
    credits: 5750,
    creditsLabel: '5,750 credits / month',
    monthlyReset: true,
    leadLimit: 30,
    leadLimitLabel: '30 active leads',
    leadValueLimit: 49999,
    leadValueLimitLabel: 'Leads valued up to $50,000',
    unlimited: false,
    color: 'blue',
    trialDays: 7,
    stripePriceId: process.env.REACT_APP_STRIPE_PRICE_STARTER || 'price_1T9v4cFQvsw8fz2CxIW2GGF1',
    stripePriceIdAnnual: process.env.REACT_APP_STRIPE_PRICE_STARTER_ANNUAL || 'price_1T9vDzFQvsw8fz2CdLPtTq2I',
    annualMonthlyPrice: 39,
    annualTotal: 470,
    features: [
      '5,750 credits per month',
      'Up to 30 active leads',
      'Leads valued up to $50,000',
      'Deep research every day',
      'Unlimited contact unlocks',
      'AI outreach emails',
      'Full activity history',
      'Data approvals & discovery',
    ],
    cta: 'Start Free Trial',
    popular: true,
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 149,
    priceLabel: 'USD $149 / month',
    image: '/images/plans/pro-plan.png',
    credits: 12000,
    creditsLabel: '12,000 credits / month',
    monthlyReset: true,
    leadLimit: 100,
    leadLimitLabel: 'Up to 100 active leads',
    leadValueLimit: -1,
    leadValueLimitLabel: 'All lead values — no cap',
    unlimited: false,
    color: 'purple',
    trialDays: 3,
    stripePriceId: process.env.REACT_APP_STRIPE_PRICE_PRO || 'price_1T9v4dFQvsw8fz2CCHKRE4YI',
    stripePriceIdAnnual: process.env.REACT_APP_STRIPE_PRICE_PRO_ANNUAL || 'price_1T9vE0FQvsw8fz2Ch6TTEMyP',
    annualMonthlyPrice: 119,
    annualTotal: 1430,
    features: [
      '12,000 credits per month',
      'Up to 100 active leads',
      'All lead values — no cap',
      'Priority AI processing',
      'Advanced analytics (coming soon)',
      'White-label reports (coming soon)',
      'Dedicated account support',
      'Early access to new features',
    ],
    cta: 'Start Free Trial',
    bestValue: true,
  },
};

export const TOPUP_PACKS = [
  {
    id: 'topup_500',
    credits: 500,
    price: 9,
    priceLabel: 'USD $9',
    label: 'Starter Pack',
    perCredit: '$0.018/cr',
    color: 'blue',
    popular: false,
    image: '/images/plans/starter-pack.png',
    stripePriceId: process.env.REACT_APP_STRIPE_PRICE_TOPUP_500 || 'price_1T9v4eFQvsw8fz2C9n1xqKXr',
  },
  {
    id: 'topup_1500',
    credits: 1500,
    price: 24,
    priceLabel: 'USD $24',
    label: 'Growth Pack',
    perCredit: '$0.016/cr',
    color: 'yellow',
    popular: true,
    image: '/images/plans/growth-pack.png',
    stripePriceId: process.env.REACT_APP_STRIPE_PRICE_TOPUP_1500 || 'price_1T9v4eFQvsw8fz2CkmW0q5vy',
  },
  {
    id: 'topup_5000',
    credits: 5000,
    price: 69,
    priceLabel: 'USD $69',
    label: 'Power Pack',
    perCredit: '$0.014/cr',
    color: 'purple',
    popular: false,
    image: '/images/plans/power-pack.png',
    stripePriceId: process.env.REACT_APP_STRIPE_PRICE_TOPUP_5000 || 'price_1T9v4fFQvsw8fz2C1zeYOjhe',
  },
];

export const AGENCY_PLAN = {
  id: 'agency',
  name: 'Agency Plan',
  monthlyPrice: 1042,
  annualTotal: 10000,
  annualMonthlyPrice: 833,
  seats: 5,
  credits: 100000,
  creditsLabel: '100,000 credits / month',
  leadLimit: -1,
  stripePriceIdMonthly: process.env.REACT_APP_STRIPE_PRICE_AGENCY_MONTHLY || 'price_1T9vl7FQvsw8fz2C1AYxzpFZ',
  stripePriceIdAnnual: process.env.REACT_APP_STRIPE_PRICE_AGENCY_ANNUAL  || 'price_1T9vl8FQvsw8fz2C3dPjjDkH',
  features: [
    'Up to 5 team seats',
    '100,000 credits per month',
    'Unlimited active leads',
    'All lead values — no cap',
    'Priority AI processing queue',
    'White-label reporting (coming soon)',
    'Dedicated agency success manager',
    'Custom onboarding & training',
    'Early access to all new features',
  ],
};

export const CREDIT_COSTS = {
  PROSPECT_FINDER_RESULT: {
    action: 'prospect_finder_search',
    cost: 1,
    label: 'AI Prospect Finder',
    description: '1 credit per new prospect found via the AI Finder',
  },
  DEEP_RESEARCH: {
    action: 'deep_research',
    cost: 125,
    label: 'Deep AI Research',
    description: 'Full AI research including Hunter.io + Apollo lookup — all in one action',
  },
  UNLOCK_WEBSITE: {
    action: 'reveal_website',
    cost: 5,
    label: 'Unlock Website',
    description: 'Unlock the business website URL',
  },
  UNLOCK_EMAIL: {
    action: 'reveal_email',
    cost: 5,
    label: 'Unlock Email',
    description: 'Unlock a hidden email address',
  },
  UNLOCK_PHONE: {
    action: 'reveal_phone',
    cost: 5,
    label: 'Unlock Phone Number',
    description: 'Unlock a hidden phone number',
  },
  SEND_OUTREACH: {
    action: 'send_outreach',
    cost: 5,
    label: 'Send Outreach Email',
    description: 'Send an AI-generated outreach email',
  },
};

export function getPlan(planId) {
  return PLANS[planId] || PLANS.free;
}

export function isUnlimited(planId) {
  return PLANS[planId]?.unlimited === true;
}

export function getLeadLimit(planId) {
  return PLANS[planId]?.leadLimit ?? 10;
}

export function getLeadValueLimit(planId) {
  return PLANS[planId]?.leadValueLimit ?? 10000;
}

export function parseLeadEstimatedValue(lead) {
  const raw = Number(lead?.estimated_value) || 0;
  if (raw > 0) return raw;
  try {
    const ai = typeof lead?.ai_json === 'string' ? JSON.parse(lead.ai_json) : (lead?.ai_json || {});
    const str = ai?.deepSearch?.estimatedBusinessValue || ai?.deepSearch?.estimatedMarketingBudget || '';
    const nums = str.replace(/,/g, '').match(/\d+/);
    return nums ? parseInt(nums[0], 10) : 0;
  } catch { return 0; }
}

export function isLeadValueBlocked(lead, planId) {
  const limit = getLeadValueLimit(planId);
  if (limit === -1) return false;
  const value = parseLeadEstimatedValue(lead);
  if (!value || value === 0) return false;
  return value > limit;
}

export function canAffordAction(credits, planId, actionKey) {
  if (isUnlimited(planId)) return true;
  const cost = CREDIT_COSTS[actionKey]?.cost ?? 0;
  return credits >= cost;
}

export function formatCredits(credits, planId) {
  if (isUnlimited(planId)) return 'Unlimited';
  return credits.toLocaleString();
}
